import { FirestoreDataConverter, SetOptions } from '@firebase/firestore';
import { isObject } from 'class-validator';
import { cloneObject } from '@shared/utils/object';
import { UnknownPartial } from '../types';
import { sanitizeFirestoreData, validateSyncAndThrow } from '../utils';
import { CanvasWidgetDto } from './dto/canvasWidget.dto';

// TODO could not use createValidatorConverter directly because of TS error.
// Is it because of the extended class?

/**
 * @returns A typed Firestore data converter that validates the payload
 * by calling class-validator with {@link CanvasWidgetDto}.
 * @template TContent - The widget's custom data, which currently isn't validated
 */
export function getCanvasWidgetConverter<
  TContent extends UnknownPartial,
>(): FirestoreDataConverter<CanvasWidgetDto<TContent>> {
  return {
    fromFirestore(snapshot, options) {
      const data = snapshot.data(options);
      const dto = new CanvasWidgetDto<TContent>(
        data as CanvasWidgetDto<TContent>,
      );
      validateSyncAndThrow(dto);
      return dto;
    },

    toFirestore(data, options?: SetOptions) {
      const isPartialData =
        isObject(options) && ('merge' in options || 'mergeFields' in options);

      const dto = new CanvasWidgetDto<TContent>(
        data as CanvasWidgetDto<TContent>,
      );
      validateSyncAndThrow(dto, { skipMissingProperties: isPartialData });

      return sanitizeFirestoreData(cloneObject(data));
    },
  };
}
